// extracted by mini-css-extract-plugin
export default {"title":"Label_title__gvg7k","space":"Label_space__Loyxk","div":"Label_div__W1ZF2"};